import posthog from "posthog-js";
import React, { ReactElement } from "react";

import DeleteActionDialog, {
  Entry,
} from "../../../components/DeleteActionDialog";
import { useSelector } from "../../../store";
import { useDeleteClusterMutation } from "../../../store/pomeriumApi";

type Props = {
  selected: Entry[];
  setShowDelete(show: boolean): void;
  showDelete: boolean;
};

const ActionToolbarDialogs = ({
  selected,
  setShowDelete,
  showDelete,
}: Props): ReactElement => {
  const [deleteCluster] = useDeleteClusterMutation();
  const { organizationId } = useSelector((state) => state.current);

  function handleCloseDelete() {
    setShowDelete(false);
  }

  async function handleDelete() {
    await Promise.all(
      selected.map((cluster) =>
        deleteCluster({ organizationId, clusterId: cluster.id }),
      ),
    );
    posthog.capture("clusters_deleted", { deleted: selected.toString() });
  }

  return (
    <DeleteActionDialog
      name="Clusters"
      open={showDelete}
      entries={selected}
      onClose={handleCloseDelete}
      onDelete={handleDelete}
    />
  );
};
export default ActionToolbarDialogs;
